import { Input } from '@app/components/various/Fields/Input';
import { Voucher } from '@app/components/various/Icons';
import { addVoucherRequest, getIsVoucherValid } from '@app/ducks';
import { isEmpty } from '@app/utils/isEmpty';
import { Key } from '@app/utils/keys';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

export const VoucherForm = () => {
  const dispatch = useDispatch();
  const isSubmittedVoucherValid = useSelector(getIsVoucherValid);
  const { t } = useTranslation(['common', 'checkout', 'validation']);
  const [voucherCode, setVoucherCode] = React.useState('');
  const [isVoucherInvalid, setIsVoucherInvalid] = React.useState(!isSubmittedVoucherValid);
  const handleVoucherInput = React.useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    setVoucherCode(event.target.value);
    setIsVoucherInvalid(false);
  }, []);

  const handleAddVoucher = React.useCallback(() => {
    if (isEmpty(voucherCode)) {
      return;
    }

    dispatch(addVoucherRequest(voucherCode));
  }, [dispatch, voucherCode]);

  React.useEffect(() => {
    setIsVoucherInvalid(!isSubmittedVoucherValid);
  }, [isSubmittedVoucherValid]);

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === Key.ENTER) {
      event.preventDefault();
      handleAddVoucher();
    }
  };

  return (
    <div className="relative mb-5">
      <span className="body-1">{t('checkout:voucher_add')}</span>
      <div className="relative mt-1">
        <Input
          onKeyDown={handleKeyDown}
          placeholder={t('checkout:voucher_code')}
          value={voucherCode}
          isInvalid={isVoucherInvalid}
          onChange={handleVoucherInput}
          className="bg-white"
        />
        <button
          type="button"
          className="absolute right-4 top-1/2 flex -translate-y-1/2 items-center text-neutral-20 transition-colors hover:text-neutral-40 focus-visible:rounded-small focus-visible:focus-outline disabled:cursor-not-allowed"
          onClick={handleAddVoucher}
          disabled={isEmpty(voucherCode)}
        >
          <Voucher />
          <span className="body-6">{t('common:apply')}</span>
        </button>
      </div>
      {isVoucherInvalid && <div className="text-error-45 body-5">{t('validation:invalid_voucher_hint')}</div>}
    </div>
  );
};
